import { useTheme } from "@/contexts/RADashboardThemeContext/hooks"
import React from "react"

const ErrorDialog: React.FC<React.PropsWithChildren<{
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
}>> = ({
  open,
  onOpenChange,
  title,
  children
}) => {
  const theme = useTheme();
  if (!open) return null

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: theme.cardBackground,
          border: `1px solid ${theme.border}`,
          borderRadius: '8px',
          padding: '32px',
          maxWidth: '500px',
          width: '90%',
          boxShadow: `0 8px 32px ${theme.benchmarkBoxShadowColor}`,
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '16px',
          }}
        >
          <h3
            style={{
              margin: 0,
              fontSize: '20px',
              fontWeight: '700',
              color: theme.textPrimary,
            }}
          >
            Error: {title}
          </h3>
          <button
            onClick={() => onOpenChange(false)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: theme.textSecondary,
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = theme.inputBackground
              e.currentTarget.style.color = theme.textPrimary
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent'
              e.currentTarget.style.color = theme.textSecondary
            }}
            title='Close dialog'
          >
            <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
              <line x1='18' y1='6' x2='6' y2='18'></line>
              <line x1='6' y1='6' x2='18' y2='18'></line>
            </svg>
          </button>
        </div>

        <p
          style={{
            margin: '0 0 24px 0',
            fontSize: '16px',
            color: theme.textSecondary,
            lineHeight: '1.5',
          }}
        >
          {children}
        </p>
      </div>
    </div>
  )
}

export default ErrorDialog;